<template>
  <div class="d-inline-flex align-center">
    <v-switch
      :loading="$wait.is('fetching products')"
      :value="showFullCatalog"
      color="#424242"
      dense
      class="mt-0 ml-4 catalog-switch"
      hide-details
      @change="SET_SHOW_FULL_CATALOG($event)"
    >
      <template v-slot:label>
        <span
          class="ml-1 white--text"
          v-text="showCatalogLabel.toUpperCase()"
        />
      </template>
    </v-switch>
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          icon
          class="ml-2 mr-n4"
          v-on="on"
          @click="reload"
        ><v-icon size="20px">sync</v-icon>
        </v-btn>
      </template>
      <span>{{ $t('Reload {0}', [$t('Products')]) }}</span>
    </v-tooltip>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CatalogSwitcher',

  data () {
    return {
      showCatalogLabel: this.$t('Store Catalog')
    }
  },

  computed: {
    ...mapState(['showFullCatalog', 'cashRegister'])
  },

  watch: {
    showFullCatalog (value) {
      this.$wait.start('fetching products')
      this.$store.dispatch('FETCH_PRODUCTS', value)
        .then(() => this.$store.dispatch('FETCH_PRODUCT_STOCKS'))
        .then(() => {
          this.showCatalogLabel = value ? this.$t('Full {0}', [this.$t('Catalog')]) : this.$t('Store Catalog')
        })
        .finally(() => this.$wait.end('fetching products'))
    }
  },

  methods: {
    ...mapActions(['SET_SHOW_FULL_CATALOG']),
    reload () {
      this.$wait.start('fetching products')
      this.$store.dispatch('FETCH_PRODUCTS')
        .then(() => this.$store.dispatch('FETCH_PRODUCT_STOCKS'))
        .finally(() => this.$wait.end('fetching products'))
    }
  }
}
</script>

<style lang="scss" scoped>
.catalog-switch {
  /deep/ span {
    font-size: .875rem;
    letter-spacing: 1.25px;
  }

  /deep/ .v-input--switch__thumb,
  /deep/ .v-input--switch__track {
    caret-color: white;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CatalogSwitcher.vue